import React from 'react';
import { styled } from '@teko/ui';

const Wrapper = styled.div`
  color: #848788;
  font-size: 0.875rem;
  display: flex;
  flex-wrap: wrap;
`;
const Variant = styled.div`
  display: flex;
`;
const Divider = styled.span`
  margin: 0 8px;
  color: #848788;
`;
const Variants = ({
  variants = []
}) => /* @__PURE__ */ React.createElement(Wrapper, null, variants.map((variant, index) => /* @__PURE__ */ React.createElement(Variant, {
  key: index
}, /* @__PURE__ */ React.createElement("div", null, variant.name, ": ", variant.value), index !== variants.length - 1 && /* @__PURE__ */ React.createElement(Divider, null, "|"))));

export { Variants };
